import { ObjectMapper } from 'json-object-mapper';
import {
	DigitalSignatureStatus,
	DigitalSignatureStatusEnum,
} from 'services/enums/digitalSignatureStatus.enum';
import { IModel } from '../IModel';
import { Model } from '../model';
import { DocumentMockupTypeEnum } from './document-mockup-type.model';
import {
	DocumentSignatureGroupDocumentModel,
	DocumentSignatureGroupModel,
} from './document-signature-group.model';
import { DocumentSignatureSignerModel } from './document-signature-signer.model';
import { DocumentSignatureBatchModel } from './document-signature-batch.model';

export class DocumentSignatureModel extends Model implements IModel<DocumentSignatureModel> {
	hashChecksumSHA256: string = '';
	limitDate: string = '';
	signatureGroupId: string = '';
	signatureBatchId: string = '';
	creatorEmployeeId: string = '';
	creatorEmployeeName: string = '';
	CreatorEmployeeImageUrl: string = '';
	originalFileS3Path: string = '';
	originalFileExtension: string = '';
	signedFileS3Path: string = '';
	signedFileExtension: string = '';
	fileName: string = '';
	fileSize: number = 0;
	status: DigitalSignatureStatus | string = '';
	signatureGroup: DocumentSignatureGroupModel;
	signatureBatch: DocumentSignatureBatchModel;

	title: string = '';
	type: string | number = 0;
	companyGroupId: string = '';
	documents?: DocumentSignatureGroupDocumentModel[] = [];
	signers?: DocumentSignatureSignerModel[] = [];
	countDocuments?: number = 0;
	countDocumentsSigned?: number = 0;
	isBatch: boolean = false;

	static create(input): DocumentSignatureModel {
		return ObjectMapper.deserialize<DocumentSignatureModel>(DocumentSignatureModel, input);
	}

	public toJSON(): string {
		return ObjectMapper.serialize(this) as string;
	}

	get isSigned() {
		return (this.countDocuments === this.countDocumentsSigned).toString();
	}

	get typeLabel(): string {
		const find = DocumentMockupTypeEnum.buildListEnum().find(
			t => t.value === this.type || t.id === this.type
		);
		return DocumentMockupTypeEnum.getBy(find.value).label;
	}

	get labelBadge(): string {
		const find = DocumentMockupTypeEnum.buildListEnum().find(
			t => t.value === this.type || t.id === this.type
		);
		return find.value === DocumentMockupTypeEnum.General.value
			? `<span class="badge badge-secondary rounded-pill">${this.typeLabel}</span>`
			: `<span class="badge badge-info rounded-pill">${this.typeLabel}</span>`;
	}

	get statusLabel(): string {
		return DigitalSignatureStatusEnum.getBy(this.status).label;
	}

	get progressPercentage() {
		return (this.countDocumentsSigned / this.countDocuments) * 100;
	}

	get progressColor() {
		const value = this.countDocumentsSigned / this.countDocuments;

		if (value < 0.5) {
			return 'danger';
		}

		if (value === 1) {
			return 'success';
		}

		return 'warning';
	}

	get progressIcon() {
		const value = this.countDocumentsSigned / this.countDocuments;

		if (value < 0.5) {
			return '';
		}

		if (value === 1) {
			return 'check';
		}

		return 'clock';
	}

	get statusProps() {
		return {
			icon: this.progressIcon,
			color: this.progressColor,
			percentage: this.progressPercentage,
		};
	}
}
